import styled from 'styled-components';
import {getToken, getSpacing} from '@tickchak/react-share/app';
import {mobileMedia} from '../../globalVariables/GlobalVariables';
import {alignStart, dFlex, dFlexColumn, flexWrap, justifyBetween} from '../../globalVariables/GlobalFlex';
import {variableDropdown} from '../variableDropdown/VariableDropdown.css';

export const topRow = styled.div`
    ${dFlex}
    ${flexWrap}
    ${justifyBetween}
    ${alignStart}
    padding-bottom: ${getSpacing('spaceLg')};
    ${mobileMedia} {
        padding-bottom: ${getSpacing('spaceMd')};
    }
`;

export const toolbar = styled.div`
    ${dFlex}
    gap: ${getSpacing('spaceSm')};
    ${variableDropdown} {
        position: relative;
        top: unset;
        inset-inline-start: unset;
        inset-inline-end: unset;
    }
`;

export const wrapper = styled.div`
    position: relative;
    border: 2px solid ${getToken('color.brand.main')};
    border-radius: var(--border-radius-border-radius-2xl);
    padding: ${getSpacing('spaceLg')};
    ${mobileMedia} {
        padding: ${getSpacing('spaceMd')};
    }
    ${p => (p.theme?.rtl && p.theme.direction === 'ltr') || (!p.theme?.rtl && p.theme.direction === 'rtl') ? 'direction: ltr;' : 'direction: rtl;'};
`;

export const paragraphsContainer = styled.div`
    flex: 1;
    ${dFlexColumn};
`;
